import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * This function is taken from the Redux Toolkit documentation.
 *
 * https://redux-toolkit.js.org/rtk-query/usage-with-typescript#error-result-example
 *
 * > When using fetchBaseQuery, the error property returned from a hook
 * > will have the type FetchBaseQueryError | SerializedError | undefined.
 * > If an error is present, you can access error properties after
 * > narrowing the type to either FetchBaseQueryError or SerializedError.
 */
export const formatFetchBaseQueryError = (
  error: FetchBaseQueryError,
): string => {
  return 'error' in error ? error.error : JSON.stringify(error.data);
};
